import type { CSSProperties, FC } from 'react';
import { LONG_DASH } from '@mwl/core-lib';
import { SportIcon } from '@/components/SportIcon/SportIcon';
import type { MatchTeamProps } from './MatchTeam.types';
import styles from './MatchTeam.module.scss';
export const MatchTeam: FC<MatchTeamProps> = ({
  team,
  sportIcon,
  sportCode,
  className,
  classes,
  imageOnly = false,
  imageSize = 40
}) => {
  if (!team) {
    return null;
  }
  return <div style={({
    '--image-size': `${imageSize}px`
  } as CSSProperties)} className={cn(styles.root, className)} data-sentry-component="MatchTeam" data-sentry-source-file="MatchTeam.tsx">
      <div className={cn(styles.image, classes?.image)}>
        <SportIcon className={styles.unknownLogo} url={team.image} fallbackUrl={sportIcon} size={imageSize} alt={team.title || sportCode || 'Team'} data-sentry-element="SportIcon" data-sentry-source-file="MatchTeam.tsx" />
      </div>

      {!imageOnly && <div title={team.title} className={cn(styles.name, classes?.name)}>
          {team.title || LONG_DASH}
        </div>}
    </div>;
};